import { RiLinkUnlinkM } from "@remixicon/react";
import { IconTile } from "@screener/uikit/components/icon-tile";
import { AuthHeading, SignInHint } from "./auth-layout";

/**
 * Экран 2c: ссылка не действует уже при открытии (stage9-auth-redesign, Д3).
 * Называет все три причины разом — демон их не различает намеренно — и
 * предлагает войти. Формы нет.
 */
export function InvalidInviteScreen() {
  return (
    <div data-slot="invalid-invite" className="flex flex-col items-center gap-5 text-center">
      <IconTile variant="destructive">
        <RiLinkUnlinkM className="size-[18px]" />
      </IconTile>
      <AuthHeading title="Ссылка недействительна">
        <p className="text-[13px] leading-normal text-muted-foreground">
          Она истекла, уже использована или отозвана. Попросите новую.
        </p>
      </AuthHeading>
      <SignInHint />
    </div>
  );
}
